//#region Imports
import { createAuthHeaders } from "@anydo/auth";
import { createHttpError, SETTINGS_API_ORIGIN_URL } from "@anydo/core";
//#endregion

export async function fetchSyncHttpExportBoardActivity(
  boardId: string,
  authToken: string,
  signal?: AbortSignal,
): Promise<void> {
  const url = SETTINGS_API_ORIGIN_URL + `/me/updates/board/${encodeURIComponent(boardId)}/export`;

  const response = await fetch(url, {
    method: "GET",
    headers: createAuthHeaders(authToken),
    signal,
  });

  if (!response.ok) {
    throw await createHttpError(response, "fetchSyncHttpExportBoardActivity");
  }
}
